import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { RolesPage } from '@/areas/settings/Settings/RolesPage/RolesPage';
import { canViewAdvancedUserManagement } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/user-management/roles')({
    staticData: { access: { permissions: canViewAdvancedUserManagement }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <RolesPage />;
}
